import React, { useState, useEffect } from 'react';
import { columns, mobileColumns } from './Column';
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable';
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize';
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable';
import ReportFooter from '../../ReportsFooter/ReportFooter';

function formatDate(dateString) {
    if (!dateString) return 'Invalid Date';
    
    const date = new Date(dateString);
    return isNaN(date) 
        ? 'Invalid Date' 
        : date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
}

const ScoreAdjustmentAnalysisTable = ({
    isLoading,
    data,
    dates,
    totaldata,
    downloadPDF,
    downloadExcel,
    handleColumnSort,
    pageCount,
    tableOptions,
    handlePageClick,
    handleRowsPerPage,
    reportData,
    reportCode,
    reportTableData,
    generatePDFFunction,
}) => {
    const size = useWindowSize();
    const [currentRow, setCurrentRow] = useState(null);
    const [payload, setPayload] = useState(() => {
        const storedData = sessionStorage.getItem('scoreAdjustmentPayload');
        try {
            const parsedData = JSON.parse(storedData);
            return parsedData && parsedData.startDate && parsedData.endDate
                ? parsedData
                : {};
        } catch {
            return {};
        }
    });

    useEffect(() => {
        if (dates?.startDate && dates?.endDate) {
            sessionStorage.setItem('scoreAdjustmentPayload', JSON.stringify(dates));
            setPayload(dates);
        }
    }, [dates]);

    const formattedStartDate = formatDate(payload?.startDate);
    const formattedEndDate = formatDate(payload?.endDate);

    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">Score Adjustment Analysis</h1>
                <h6 className="text-muted mb-4 fw-normal">
                    The grid below shows score change data for incidents created between {formattedStartDate} and {formattedEndDate}.
                </h6>
                <ReactExpandableTable
                    isLoading={isLoading}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    data={data?.data}
                    totaldata={totaldata}
                    mobileColumns={mobileColumns}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    handleColumnSort={handleColumnSort}
                    handleRowsPerPage={handleRowsPerPage}
                    removePagination={false}
                    handlePageClick={handlePageClick}
                />
                <ReportFooter
                    BackText="Back"
                    PdfText="PDF"
                    MailText="Mail"
                    ExcelText="Excel"
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                />
            </>
        );
    }

    return (
        <>
            <h1 className="mb-2">Score Adjustment Analysis</h1>
            <h6 className="text-muted mb-4 fw-normal">
                The grid below shows score change data for incidents created between {formattedStartDate} and {formattedEndDate}.
            </h6>
            <ReactDataTable
                isLoading={isLoading}
                data={data?.data}
                columns={columns}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                totaldata={totaldata}
                handleRowsPerPage={handleRowsPerPage}
                removePagination={false}
                handleColumnSort={handleColumnSort}
                handlePageClick={handlePageClick}
            />
            <ReportFooter
                BackText="Back"
                PdfText="PDF"
                MailText="Mail"
                ExcelText="Excel"
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                generatePDFFunction={generatePDFFunction}
            />
        </>
    );
};

export default ScoreAdjustmentAnalysisTable;
